import { Button } from "primereact/button";
import { Checkbox } from "primereact/checkbox";
import { Dialog } from "primereact/dialog";
import React, { useEffect, useState } from "react";
import { formatDate } from "../../../constants/FormateDate";

const CustomerPackageOfferSubscriptionFilterModal = ({
  customerPackageOfferSubscriptionFilterModalVisible,
  setCustomerPackageOfferSubscriptionFilterModalVisible,
  sendDataToOrdersPageFromFilter,
  OrderCustomerPackageOfferSubscription,
  status,
  text,
}) => {
  const [selectedCustomerPackageOfferSubscription, setSelectedCustomerPackageOfferSubscription] = useState([]);

  useEffect(() => {
    // Update localSelectedStatus when selectedStatus changes
    setSelectedCustomerPackageOfferSubscription(OrderCustomerPackageOfferSubscription.map((item) => item.id && item.payment.processed === "true"));
  }, [OrderCustomerPackageOfferSubscription]);

  const handleCustomerPackageOfferSubscriptionToggle = (customerPackageOfferSubscription) => {
    const updatedCustomerPackageOfferSubscription = [customerPackageOfferSubscription];

    setSelectedCustomerPackageOfferSubscription(updatedCustomerPackageOfferSubscription);
  };

  const formatDateLedger = (dateString) => {
    const parsedDate = new Date(dateString.replace("Z", ""));

    return parsedDate.toLocaleString("en-GB", {
      month: "2-digit",
      day: "2-digit",
      year: "2-digit",
      hour12: true,
    });
  };

  const handleConfirmPickup = () => {
    // Close the modal
    setCustomerPackageOfferSubscriptionFilterModalVisible(false);
    sendDataToOrdersPageFromFilter(
      selectedCustomerPackageOfferSubscription.length > 0 ? selectedCustomerPackageOfferSubscription : "ALL"
    );
  };

  const handleModalClose = () => {
    setCustomerPackageOfferSubscriptionFilterModalVisible(false);
  };

  return (
    <div className="flex justify-content-center">
      <Dialog
        modal
        visible={customerPackageOfferSubscriptionFilterModalVisible}
        style={{ width: "50vw" }}
        onHide={() => {
          if (!customerPackageOfferSubscriptionFilterModalVisible) return;
          handleModalClose();
        }}
        content={({ hide }) => (
          <div
            className="flex flex-column gap-4 "
            style={{
              borderRadius: "12px",
              backgroundColor: "#fff",
            }}
          >
            <div
              className="flex border-round-xl  justify-content-between align-items-center gap-2 px-4 py-2"
              style={{
                backgroundImage:
                  "radial-gradient(circle at left top, #2B70D7, #1752AA)",
              }}
            >
              <img
                style={{
                  height: 45,
                  width: 45,
                  // alignSelf: 'center',
                }}
                src={"Laundy_App_Icons_Gifs/Other_Icons/filter.png"}
              />

              <p className=" text-4xl text-primary-50 font-semibold">
                Select Offer Subscription Date
              </p>
              <Button
                label="x"
                onClick={(e) => hide(e)}
                text
                className=" text-2xl text-primary-50 border-1 border-white-alpha-30 hover:bg-white-alpha-10"
              ></Button>
            </div>

            <div
              className="h-20rem scroll-bar mb-2"
              style={{
                overflowY: "scroll",
              }}
            >
              <div className="mx-4">
                {OrderCustomerPackageOfferSubscription?.map((customerPackageOfferSubscriptionItem) => (
                  <div
                    key={customerPackageOfferSubscriptionItem}
                    className="flex flex-1 justify-content-between my-1"
                  >
                    <p className="text-xl font-medium">
                      {formatDateLedger(customerPackageOfferSubscriptionItem.payment.date)}
                    </p>
                    <div>
                      <Checkbox
                        checked={selectedCustomerPackageOfferSubscription.includes(
                          customerPackageOfferSubscriptionItem.id
                        )}
                        size="20" // Increased size
                        color={
                          selectedCustomerPackageOfferSubscription.includes(customerPackageOfferSubscriptionItem.id)
                            ? "#00A3FF"
                            : "#C1C9D3"
                        }
                        onClick={() =>
                          handleCustomerPackageOfferSubscriptionToggle(customerPackageOfferSubscriptionItem.id)
                        }
                      />
                    </div>
                  </div>
                ))}
              </div>
            </div>

            <Button
              onClick={handleConfirmPickup}
              className="mt-1 mb-3 mx-4 border-round-xl "
            >
              <p className=" w-full text-2xl font-semibold flex justify-content-center">
                Filter
              </p>
            </Button>
          </div>
        )}
      ></Dialog>
    </div>
  );
};

export default CustomerPackageOfferSubscriptionFilterModal;
